import axios from "axios";
import ServiceHelper from "./serviceHelper";
import envConfig from "../config";
class HorseService {
  static GetHorse(horseId) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .get(`${envConfig.apiBaseUrl}/api/horse/horse/${horseId}`, config)
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        return;
      });
  }

  static AddNote(note) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .post(`${envConfig.apiBaseUrl}/api/horse/addNote`, note, config)
      .then((response) => {
        ServiceHelper.ApiCallPostValidation(response, "create");
        return true;
      })
      .catch((error) => {
        ServiceHelper.ApiCallPostCatchValidation(error);
        return false;
      });
  }

  static UpdateNote(externalId, editNote) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    editNote.externalId = externalId;

    return axios
      .post(`${envConfig.apiBaseUrl}/api/horse/editNote`, editNote, config)
      .then((response) => {
        ServiceHelper.ApiCallPostValidation(response, "update");
        return response.data.success;
      })
      .catch((error) => {
        ServiceHelper.ApiCallPostCatchValidation(error);
        return false;
      });
  }

  static ArchiveHorse(horseId) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .post(`${envConfig.apiBaseUrl}/api/horse/archive/${horseId}`, {}, config)
      .then((response) => {
        ServiceHelper.ApiCallPostValidation(response, "archive");
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        throw error;
      });
  }

  static UnarchiveHorse(horseId) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .post(`${envConfig.apiBaseUrl}/api/horse/unarchive/${horseId}`, {}, config)
      .then((response) => {
        ServiceHelper.ApiCallPostValidation(response, "unarchive");
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        throw error;
      });
  }

  static DeleteNote(externalId) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .delete(`${envConfig.apiBaseUrl}/api/horse/deleteNote/${externalId}`, config)
      .then((response) => {
        ServiceHelper.ApiCallPostValidation(response, "delete");
        return true;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        return;
      });
  }

  static AddMedia(fileId, externalId) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();
    let postUrl = "";
    let obj = null;
    if (Array.isArray(fileId)) {
      postUrl = `${envConfig.apiBaseUrl}/api/horse/addMedias`;
      obj = { fileIds: fileId, externalId };
    } else {
      postUrl = `${envConfig.apiBaseUrl}/api/horse/addMedia`;
      obj = { fileId, externalId };
    }

    return axios
      .post(postUrl, obj, config)
      .then((response) => {
        ServiceHelper.ApiCallPostValidation(response, "create");
        return true;
      })
      .catch((error) => {
        ServiceHelper.ApiCallPostCatchValidation(error);
        return false;
      });
  }

  static GetHorses() {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .get(`${envConfig.apiBaseUrl}/api/horse/horses`, config)
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
      });
  }

  static GetDetailHorse(horseId) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .get(`${envConfig.apiBaseUrl}/api/horse/detailhorse/${horseId}`, config)
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        return;
      });
  }

  static DeleteHorse(horseId) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .delete(`${envConfig.apiBaseUrl}/api/horse/delete/${horseId}`, config)
      .then((response) => {
        ServiceHelper.ApiCallPostValidation(response, "delete");
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        return;
      });
  }

  static GetHorsesForClient(clientId) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .get(`${envConfig.apiBaseUrl}/api/client/clients`, config)
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        return;
      });
  }

  static Update(horse) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    if (horse.defaultImageId === "") {
      horse.defaultImageId = null;
    }

    return axios
      .post(`${envConfig.apiBaseUrl}/api/horse/update`, horse, config)
      .then((response) => {
        ServiceHelper.ApiCallPostValidation(response, "update");
        return response.data.success;
      })
      .catch((error) => {
        ServiceHelper.ApiCallPostCatchValidation(error);
        return false;
      });
  }

  static QuickCreate(horse) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();
    if (horse.defaultImageId === "") {
      horse.defaultImageId = null;
    }
    if (horse.birthDate === "") {
      horse.birthDate = null;
    }
    return axios
      .post(`${envConfig.apiBaseUrl}/api/horse/quickcreate`, horse, config)
      .then((response) => {
        ServiceHelper.ApiCallPostValidation(response, "create");
        return ServiceHelper.IsEmptyGuid(response.data.data) ? null : response.data.data;
      })
      .catch((error) => {
        ServiceHelper.ApiCallPostCatchValidation(error);
        return false;
      });
  }
}

export default HorseService;
